import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";

//Styles
import "./HowItWorks.scss";

//Components
import Button from "common-components/Button/Button";
import RevealOnScroll from "common-components/RevealOnScroll/RevealOnScroll";

import { ReactComponent as BlockTopSvg } from "assets/how-it-works-top.svg";
import { ReactComponent as BottomLine } from "assets/how-it-works-bottom.svg";
import { ReactComponent as Screenshot1 } from "assets/screenshots/1.svg";
import { ReactComponent as StepsLine } from "assets/steps-line.svg";
import { ReactComponent as StepsLineMobile } from "assets/steps-line-mobile.svg";

//Assets
import Screenshot2 from "assets/screenshots/2.jpg"; //Supposed to be 2x (retina) images
import Screenshot3 from "assets/screenshots/3.jpg";

function HowItWorks() {
  const [currentStep, setCurrentStep] = useState(0);
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      setCurrentStep(currentStep + 1 > 2 ? 2 : currentStep + 1);
    },
    onSwipedRight: () => {
      setCurrentStep(currentStep - 1 < 0 ? 0 : currentStep - 1);
    },
    trackMouse: true
  });
  return (
    <section className="page-landing how-it-works">
      <BlockTopSvg className="top-svg" />
      <div className="m-width-wrapper">
        <RevealOnScroll>
          <h2>How it works</h2>
        </RevealOnScroll>
        <div className="steps" {...swipeHandlers}>
          <div className="steps-inner" style={{ "--current-step": currentStep }}>
            <RevealOnScroll>
              <div className="step">
                <div className="info">
                  <h3>Set up your brief</h3>
                  <p>Just fill out simple online form and in just minutes, our designers will get started on your Logo Design right away!</p>
                </div>
                <div className="number">1</div>
                <div className="screenshot">
                  <Screenshot1 className="animated-screenshot" />
                </div>
              </div>
            </RevealOnScroll>
            <RevealOnScroll>
              <div className="step">
                <div className="info">
                  <h3>Review & provide feedback</h3>
                  <p>Just fill out simple online form and in just minutes, our designers will get started on your Logo Design right away!</p>
                </div>
                <div className="number">2</div>
                <div className="screenshot">
                  <img srcSet={Screenshot2 + " 2x"} alt="Review and provide feedback interface screenshot" />
                </div>
              </div>
            </RevealOnScroll>
            <RevealOnScroll>
              <div className="step">
                <div className="info">
                  <h3>Pick a winning design!</h3>
                  <p>Just fill out simple online form and in just minutes, our designers will get started on your Logo Design right away!</p>
                </div>
                <div className="number">3</div>
                <div className="screenshot">
                  <img srcSet={Screenshot3 + " 2x"} alt="Pick a winning design interface screenshot" />
                </div>
              </div>
            </RevealOnScroll>
            <StepsLine className="steps-line" />
            <StepsLineMobile className="steps-line-mobile" />
          </div>
          <button
            className="mobile-cards-switcher prev"
            onClick={() => {
              setCurrentStep(currentStep - 1 < 0 ? 0 : currentStep - 1);
            }}
          ></button>
          <button
            className="mobile-cards-switcher next"
            onClick={() => {
              setCurrentStep(currentStep + 1 > 2 ? 2 : currentStep + 1);
            }}
          ></button>
        </div>
      </div>
      <div className="clickers">
        {[0, 1, 2].map(el => (
          <button
            key={el}
            className={el === currentStep ? "active" : null}
            onClick={() => {
              setCurrentStep(el);
            }}
          >
            <span></span>
          </button>
        ))}
      </div>
      <div className="bottom-buttons">
        <BottomLine className="bottom-line" />
        <Button styleType="primary rounded">Get started</Button>
        <Button styleType="secondary rounded">Try a demo</Button>
      </div>
    </section>
  );
}

export default HowItWorks;
